// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__U9GXO","contactForm":"Contact_contactForm__zhMVJ"};